import { render, staticRenderFns } from "./EditVendorContract.vue?vue&type=template&id=ec5c20f4"
import script from "./EditVendorContract.vue?vue&type=script&lang=ts"
export * from "./EditVendorContract.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports